module.exports = __webpack_public_path__ + "img/Janio.41e505ed.png";